// mparle-product-gallery.js — thumbnail swap + mobile swipe + lightbox + variant pill selector
(function () {
  // ---------- Thumbnail swap + mobile dots (classList only, no innerHTML risk) ----------
  const thumbs = document.querySelectorAll('[data-mp-thumb]');
  const photos = document.querySelectorAll('[data-mp-photo]');
  const dots = document.querySelectorAll('[data-mp-dot]');
  const counter = document.querySelector('[data-mp-photo-counter]');
  const mainStage = document.querySelector('[data-mp-pdp-main]');
  const total = photos.length;
  const mobileMQ = window.matchMedia('(max-width: 980px)');

  function activatePhoto(idx) {
    thumbs.forEach(b => b.classList.toggle('is-active', b.dataset.mpThumb === String(idx)));
    photos.forEach(p => p.classList.toggle('is-active', p.dataset.mpPhoto === String(idx)));
    dots.forEach(d => d.classList.toggle('is-active', d.dataset.mpDot === String(idx)));
    if (counter) counter.textContent = `${Number(idx) + 1} / ${total}`;
  }

  thumbs.forEach(btn => {
    btn.addEventListener('click', () => activatePhoto(btn.dataset.mpThumb));
  });

  // Mobile: swipe-sync — scroll-position bepaalt actieve foto/dot
  if (mainStage && dots.length) {
    let raf = 0;
    function syncFromScroll() {
      raf = 0;
      const w = mainStage.clientWidth;
      if (!w) return;
      const idx = Math.round(mainStage.scrollLeft / w);
      const clamped = Math.max(0, Math.min(total - 1, idx));
      activatePhoto(clamped);
    }
    mainStage.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(syncFromScroll);
    }, { passive: true });

    dots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        e.stopPropagation();
        if (!mobileMQ.matches) return;
        const idx = Number(dot.dataset.mpDot);
        const w = mainStage.clientWidth;
        mainStage.scrollTo({ left: idx * w, behavior: 'smooth' });
      });
    });
  }

  // ---------- Lightbox (zoom-on-click) ----------
  if (mainStage) {
    mainStage.addEventListener('click', () => {
      const active = document.querySelector('[data-mp-photo].is-active img');
      if (!active) return;
      const lb = document.createElement('div');
      lb.className = 'mp-pdp__lightbox is-open';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');

      const img = document.createElement('img');
      img.src = active.currentSrc || active.src;
      img.alt = active.alt || '';

      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'mp-pdp__lightbox-close';
      close.textContent = 'Sluiten';
      close.setAttribute('aria-label', 'Sluit afbeelding');

      lb.appendChild(img);
      lb.appendChild(close);
      document.body.appendChild(lb);

      const dismiss = () => lb.remove();
      close.addEventListener('click', dismiss);
      lb.addEventListener('click', (e) => { if (e.target === lb) dismiss(); });
      document.addEventListener('keydown', function esc(e) {
        if (e.key === 'Escape') { dismiss(); document.removeEventListener('keydown', esc); }
      });
    });
  }

  // ---------- Variant pill selection ----------
  const variantInput = document.querySelector('[data-mp-variant-id]');
  const form = document.querySelector('[data-mp-cart-form]');
  if (!variantInput || !form) return;

  const handleMeta = document.querySelector('meta[name="mp-current-product-handle"]');
  const productHandle = handleMeta ? handleMeta.content : null;
  if (!productHandle) return;

  let productData = null;
  async function loadProduct() {
    if (productData) return productData;
    try {
      const res = await fetch(`/products/${productHandle}.js`);
      if (!res.ok) return null;
      productData = await res.json();
      return productData;
    } catch (err) {
      return null;
    }
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  document.querySelectorAll('[data-mp-variant-value]').forEach(pill => {
    pill.addEventListener('click', async () => {
      if (pill.classList.contains('is-disabled')) return;

      // Mark this pill selected within its option group
      const optionGroup = pill.closest('[data-mp-option]');
      if (optionGroup) {
        optionGroup.querySelectorAll('[data-mp-variant-value]').forEach(p => p.classList.remove('is-selected'));
        pill.classList.add('is-selected');
      }

      // Read all currently-selected option values keyed by option position
      const selected = {};
      document.querySelectorAll('[data-mp-option]').forEach(group => {
        const sel = group.querySelector('[data-mp-variant-value].is-selected');
        if (sel) selected[parseInt(group.dataset.mpOption, 10)] = sel.dataset.mpVariantValue;
      });

      const product = await loadProduct();
      if (!product) return;

      // Find matching variant
      const match = product.variants.find(v => {
        return Object.entries(selected).every(([pos, val]) => v[`option${pos}`] === val);
      });

      if (match) {
        variantInput.value = match.id;

        // Update price display
        const priceEl = document.querySelector('[data-mp-price]');
        if (priceEl && match.price !== undefined) {
          priceEl.textContent = formatMoney(match.price);
        }

        // Update CTA disabled state
        const cta = form.querySelector('button[type="submit"]');
        if (cta) cta.disabled = !match.available;
      }
    });
  });
})();
